import React from 'react';
import TopupProductRowProperties from "./TopupProductsRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import TopupProductRowMedium from "./TopupProductsRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import TopupProductRowSmall from "./TopupProductsRowSmall";


const TopupProductRow: React.FC<TopupProductRowProperties> = ({
                                                    topupProduct,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <TopupProductRowSmall onUpdate={onUpdate} topupProduct={topupProduct}/>
            </ViewSmall>
            <ViewMedium>
                <TopupProductRowMedium onUpdate={onUpdate} topupProduct={topupProduct}/>
            </ViewMedium>
            <ViewLarge>
                <TopupProductRowMedium onUpdate={onUpdate} topupProduct={topupProduct}/>
            </ViewLarge>
        </>
    )
}

export default TopupProductRow;
